// extracted by mini-css-extract-plugin
export var callout = "Home-module--callout--30bcb";
export var callouter = "Home-module--callouter--f1141";
export var home = "Home-module--home--3ccaa";